import { getLoadingMessage } from '../../../r/utils';

const defaultState = {
  error: '',
  loading: true,
  message: getLoadingMessage(),
  plotlyChart: {
    data: [],
    layout: {title: 'FormPlus Plot', autosize: true},
    config: {
      toImageButtonOptions: {
        format: 'png',
        filename: 'FormPlusCharts',
        height: 500,
        width: 700,
        scale: 1
      },
      autosizable: true,
      displaylogo: false,
      displayModeBar: false,
      responsive: true,
      'modeBarButtonsToRemove': ['sendDataToCloud', 'zoom2d', 'pan2d', 
        'select2d', 'lasso2d', 'resetScale2d', 'toggleSpikelines',
        'hoverClosestCartesian', 'hoverCompareCartesian']
    }
  },
  plotlyCharts: [],
  report: {},
  records: [],
  multipleChoiceFields: ['select_basic', 'select_multiple', 'checkboxes',
    'radio_buttons', 'star_rating', 'heart_rating', 'scale_rating',
    'matrix_rating', 'smiley_rating', 'image_choice'
  ],
  submissionsCount: 0,
  responses: [],
  chartColorGroups: [
    ['#C5D86D', '#F46036', '#2E294E', '#1B998B', '#E71D36'],
    ['#003E1F', '#D96C06', '#BDBF09', '#2292A4', '#48304D'],
    ['#73BA9B', '#BA2D0B', '#FAA916', '#3F6634', '#52FFEE'],
    ['#1FB7A3', '#032B43', '#3F88C5', '#FFBA08', '#D00000'],
    ['#F9DC5C', '#BCEDF6', '#ED254E', '#4C2A85', '#59C3C3'],
    ['#5F00BA', '#43BCCD', '#EA3546', '#173753', '#F9C80E'],
    ['#264653', '#2A9D8F', '#E9C46A', '#F4A261', '#E76F51'],
    ['#FD9A30', '#7EFD39', '#6F2DBD', '#FFE66D'],
    ['#FF6B6B', '#4ECDC4', '#DC493A', '#FC2BC5'],
    ['#2667FF', '#03A777', '#820263', '#D90568'],
    ['#F65C04', '#ABFF4F', '#FF9915', '#0ABDBD'],
    ['#29BF12', '#DA222A', '#1F7A8C', '#063B5E'],
    ['#003E1F', '#73BA9B', '#A31722', '#ED217C'],
    ['#C3423F', '#9BC53D', '#FDE74C', '#5BC0EB'],
    ['#69124A', '#080B39', '#14527C', '#F248B6']
  ],
  fields: [],
  reportID: 0
}

export default function reportReducers (state=defaultState, action) {
  const { type, payload } = action
  switch (type) {
    case 'FETCH_REPORT_SUCCESS': {
      payload.report = {
        chartsInfo: JSON.parse(payload.report.charts_info),
        default: payload.report.default,
        reportDescription: payload.report.description,
        reportID: payload.reportID,
        shareReport: payload.report.share_report,
        reportTitle: payload.report.title,
        allFieldsFilters: payload.report.all_fields_filter,
      }
      return { ...state, ...payload }
    }

    default: {
      return state
    }
  }
}